import React, { useRef,useEffect, useState,useCallback } from "react";
import STARTERPACKAGE from "../../assets/img/STARTER-PACKAGE.svg";

import BASICPACKAGE from "../../assets/img/BASIC-PACKAGE.svg";

import { PackageDetails } from "../../api/apiService";
import STANDARDPACKAGE from "../../assets/img/STANDARD-PACKAGE.svg";
import PREMIUMPACKAGE from "../../assets/img/PREMIUM-PACKAGE.svg";
import USDTIMG from "../../assets/img/USDT.svg";
import Loader from "../../components/Loader";
import BNBIMG from "../../assets/img/BNBLogo.svg";
import { BNBUSDTContract, USDTContract } from "../../config/contractConfig";
import USDTABI from "../../abis/USDTABI.json";
import BNBUSDTContractABI from "../../abis/BNBUSDTContractABI.json";
import Web3 from "web3";
import { useConnectorClient, useSwitchChain } from "wagmi";
import { useAppKitAccount } from "@reown/appkit/react";
import { useToken } from "../../components/TokenContext";
import AlertMessage from "../../components/AlertMessage";
import { useLocation, useNavigate } from "react-router-dom";


const BuyPackage = () => {
    const [tableData, setTableData] = useState([]);
      const [loading, setLoading] = useState(false);
      const isFetchedRef = useRef(false);
  const { data: client } = useConnectorClient();
  const [web3, setWeb3] = useState(null);
  const [approvedPackages, setApprovedPackages] = useState(false); // 🔥 MAIN STATE
 const { address, isConnected, chainId } = useAppKitAccount();
  const [reactalert, setAlert] = useState({ type: "", message: "" });
  const { token, fetchToken } = useToken();
  const [packageAmounts , setPackageAmounts ] = useState("0");
    const [packages, setPackages] = useState([]);
      const [bnbBalance, setBNBBalance] = useState("0.0000");
  const [usdtBalance, setUSDTBalance] = useState("0.0000");
  const navigate = useNavigate();

useEffect(() => {
    const initWeb3 = () => {
      let provider = null;

      if (client && client.transport) provider = client.transport;
      else if (typeof window !== "undefined" && window.ethereum) provider = window.ethereum;

      if (!provider) return setWeb3(null);

      const w3 = new Web3(provider);
      setWeb3(w3);
    };

    initWeb3();
  }, [client]);

  useEffect(() => {
    if (!token) {
      fetchToken(); // Optional: Refetch If Token Is Null
    }
  }, [token]);

  const loadBalances = async () => {
    if (!address || !web3) return;

    try {
      const bnb = await web3.eth.getBalance(address);
      setBNBBalance(Number(web3.utils.fromWei(bnb, "ether")).toFixed(4));

      const usdtInstance = new web3.eth.Contract(USDTABI, USDTContract);
      const bal = await usdtInstance.methods.balanceOf(address).call();
      setUSDTBalance(Number(web3.utils.fromWei(bal, "ether")).toFixed(4));
    } catch (error) {
      console.log("Balance error:", error);
    }
  };

  useEffect(() => {
    if (address) loadBalances();
  }, [address, web3]);


 const fetchPackageDetails = useCallback(async () => {
  setLoading(true);
  try {
    const currentToken = token || (await fetchToken());
    if (!currentToken) return;

    const loginToken =
      localStorage.getItem("LoginToken") || currentToken;

    const res = await PackageDetails(currentToken, loginToken);

    if (res?.status && Array.isArray(res.DataList)) {
      setPackages(res.DataList);
    } else {
      setPackages([]);
    }
  } catch (err) {
    setPackages([]);
  } finally {
    setLoading(false); // ✅ loader stops once
  }
}, [token, fetchToken]);


 useEffect(() => {
  if (isFetchedRef.current) return; // 🚫 block second call
  isFetchedRef.current = true;
  fetchPackageDetails();
}, [fetchPackageDetails]);

    const getPackageImage = (name) => {
    if (name.includes("STARTER")) return STARTERPACKAGE;
    if (name.includes("BASIC")) return BASICPACKAGE;
    if (name.includes("STANDARD")) return STANDARDPACKAGE;
    if (name.includes("PREMIUM")) return PREMIUMPACKAGE;
    return STARTERPACKAGE;
  };
    const getPackageClass = (name) => {
     if (name.includes("STARTER")) return "package_card pk_color_1";
     if (name.includes("BASIC")) return "package_card pk_color_2";
     if (name.includes("STANDARD")) return "package_card pk_color_3";
     if (name.includes("PREMIUM")) return "package_card pk_color_4";
     return STARTERPACKAGE;
   };

 // =================================================
  // 🔥 APPROVE PACKAGE
  // =================================================
  const handleApprove = async (pkg) => {

    const amount = packageAmounts[pkg.PID];

    if (!address) {
    setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "error", message: "Wallet not connected!" }
    }));
    return;
  }

  if (!amount || amount % 50 !== 0) {
    setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "error", message: "Amount must be multiple of 50!" }
    }));
    return;
  }

    try {
    const usdt = new web3.eth.Contract(USDTABI, USDTContract);
    const requiredAmount = web3.utils.toWei(amount, "ether");


      await usdt.methods.approve(BNBUSDTContract, requiredAmount).send({ from: address });
       setApprovedPackages(prev => ({...prev,[pkg.PID]: true
       }));

      setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "success", message: "Approval successful!" }
    }));
  } catch (err) {
    setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "error", message: "Approval failed!" }
    }));
  }
};

  // =================================================
  // 🔥 PURCHASE PACKAGE
  // =================================================
  const handlePurchase = async (pkg) => {
 if (!address) {
    setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "error", message: "Wallet not connected!" }
    }));
    return;
  }
    const amount1 = packageAmounts[pkg.PID];
  if (!amount1 || amount1 % 50 !== 0) {
    setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "error", message: "Amount must be multiple of 50!" }
    }));
    return;
  }
     if (!approvedPackages[pkg.PID]) {
    setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "error", message: "Please approve first!" }
    }));
    return;
  }

    try {
      const contract = new web3.eth.Contract(
        BNBUSDTContractABI,
        BNBUSDTContract
      );

      const amount = web3.utils.toWei(packageAmounts[pkg.PID].toString(),"ether");
      const Packageid=pkg.PID - 1;
      await contract.methods.packagePurchase(Packageid, amount).send({ from: address });

     setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "success", message: "Package purchased successfully!" }
    }));

    setTimeout(() => window.location.reload(), 3000);
  } catch (err) {
    setAlert(prev => ({
      ...prev,
      [pkg.PID]: { type: "error", message: "Purchase failed!" }
    }));
  }
};

if (loading) {
  return <Loader />;
}
  return (
    <>
      <h4 className="mb-3 text-white">Buy Package</h4>

      {/* WALLET BALANCE */}



      <div className="wallet-balance-card row">

        <div className="col-md-6">
          <div className="wallet-item  USDTlogo mb-3">
            <div className="wallet-icon"> 
              <img src={USDTIMG} alt="" />
              </div>
            <div className="wallet-info">
              <span>USDT Balance</span>
              <b>{usdtBalance} USDT</b>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="wallet-item BNBlogo mb-3">
            <div className="wallet-icon">
              <img src={BNBIMG} alt="" />
            </div>
            <div className="wallet-info">
              <span>BNB Balance</span>
              <b>{bnbBalance} BNB</b>
            </div>
          </div>
        </div>
      </div>




       <div className="row package_row">
        {packages.map(pkg => (
          <div className="col-md-6 col-lg-3"  key={pkg.PID}>
            <div className={getPackageClass(pkg.PACKAGENAME)}>
              <div className="package-name-card">
                <h5>{pkg.PACKAGENAME}</h5>
                <h4>${pkg.AMOUNT} - ${pkg.MAXLOAD}</h4>
                <div className="dictext">{pkg.StakingPercentage}% per Day</div>
                <span className="rank_icon">
                  <img src={getPackageClass(pkg.PACKAGENAME)} alt="" />
                </span>
              </div>

              <div className="buy-package-wrp">
                <div className="price-input">
                  <i className="fa-solid fa-dollar-sign"></i>
                  <input
                    className="form-control"
                    placeholder="Enter amount"
                    value={packageAmounts[pkg.PID] || ""}
                    onChange={(e) =>
                      setPackageAmounts(prev => ({
                        ...prev,
                        [pkg.PID]: e.target.value.replace(/\D/g, "")
                      }))
                    }
                  />
                </div>
 {reactalert[pkg.PID]?.message && (
  <AlertMessage
    type={reactalert[pkg.PID].type}
    message={reactalert[pkg.PID].message}
    onClose={() =>
      setAlert(prev => ({
        ...prev,
        [pkg.PID]: { type: "", message: "" }
      }))
    }
  />
)}

                {!approvedPackages[pkg.PID] ? (
                  <button
                    className="new_joining_btn purchase-btn"
                    onClick={() => handleApprove(pkg)}
                  >
                    APPROVE
                  </button>
                ) : (
                  <button
                    className="new_joining_btn purchase-btn"
                    onClick={() => handlePurchase(pkg)}
                  >
                    PURCHASE
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}

        {/* <div className="col-md-6 col-lg-3">
          <div className="package_card pk_color_2">
            <div className="package-name-card">
              <h5>BASIC PACKAGE</h5>
              <h4>
                501 - $2000
              </h4>
              <div className="dictext">0.75% per Day</div>

              <span className="rank_icon">
                <img src={BASICPACKAGE} alt="Basic Package" />
              </span>
            </div>
            <div className="buy-package-wrp">
              <div className="price-input">
           
                <i class="fa-solid fa-dollar-sign"></i>
                <input
                  type="number"
                  className="form-control"
                  id="starterAmount1"
                  placeholder="Enter amount"
                />
              </div>
              <div
                className="new_joining_btn purchase-btn"
                data-packageid="1"
                data-inputid="starterAmount1"
              >
                PURCHASE
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3">
          <div className="package_card pk_color_3">
            <div className="package-name-card">
              <h5>STANDARD PACKAGE</h5>
              <h4>
                $2001 - $5000
              </h4>

              <div className="dictext">0.8% per Day</div>
              <span className="rank_icon">
                <img src={STANDARDPACKAGE} alt="Standard Package" />
              </span>
            </div>
            <div className="buy-package-wrp">
              <div className="price-input">
            
                <i class="fa-solid fa-dollar-sign"></i>
                <input
                  type="number"
                  className="form-control"
                  id="starterAmount2"
                  placeholder="Enter amount"
                />
              </div>
              <div
                className="new_joining_btn purchase-btn"
                data-packageid="2"
                data-inputid="starterAmount2"
              >
                PURCHASE
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-3">
          <div className="package_card pk_color_4">
            <div className="package-name-card">
              <h5>PREMIUM PACKAGE</h5>
              <h4>
                $5001 - $10000
              </h4>

              <div className="dictext">1% Per Day</div>
              <span className="rank_icon">
                <img src={PREMIUMPACKAGE} alt="Premium Package" />
              </span>
            </div>
            <div className="buy-package-wrp">
              <div className="price-input">
              
                <i class="fa-solid fa-dollar-sign"></i>
                <input
                  type="number"
                  className="form-control"
                  id="starterAmount3"
                  placeholder="Enter amount"
                />
              </div>
              <div
                className="new_joining_btn purchase-btn"
                data-packageid="3"
                data-inputid="starterAmount3"
              >
                PURCHASE
              </div>
            </div>
          </div>
        </div> */}
      </div>

    </>
  );
};

export default BuyPackage;
